import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import MuiButton from '../muiButton'
import { LEGEND_TEXT_COLOR_MAP, thinScrollbar } from '../../constants'

export const VerbatimWrapper = styled(Box)(`
    margin-top:10px;
    width:100% !important;
    padding:0 10px !important;
    background: #FFFFFF;
    border-radius: 2px;
`)

export const Wrapper = styled('ul')(
  (props) => `
    padding-left:15px;
    width:100%;
    padding: 15px 15px 10px 30px;
    list-style:none;
    background-color:${props.bg}
`
)

export const VerbatimImgVidWrapper = styled('div')(`
	column-width: 265px;
	column-gap: 12px;
  padding-left: 6px;
`)

export const ImgWrapper = styled('div')(`
  padding: 10px 10px 10px 10px;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 16px;
  color:#000 !important;
	margin: 0 2px 10px;
  display: inline-block;
  // max-width:300px;
  column-break-inside: avoid;
  border: 1px solid #ADADAC;
  position: relative;
  border-radius: 4px;

  & svg{
    position: absolute;
    left: -7px;
    top: 9px;
    background: #fff;
  }
  
  & img { 
    width: 100%; height: auto;
    margin-bottom: 0;
    border-radius: 4px;
  }

  & span { padding: 8px 0px 0px 0px; position: relative; display: block; overflow-wrap:anywhere; }
  & strong { 
    color: #000; margin-left: 8px; font-size: 12px;
    font-weight: 400; // 300;
  }

  & span:before { position: absolute; left:2px; top:10px; font-size:14px; }

  &.Positive:after {
    content: '';
    position: absolute;
    left: -10px;
    top: 6px;
    height: 20px;
    width: 20px;
    border-top: 1px solid #ADADAC;
    border-bottom: 1px solid #ADADAC;
    border-left: none;
    border-right: none;
    border-radius: 50%;
    background-color: transparent;
  }
  &.Positive span{ color: #21B979; }
  &.Positive:hover{background-color: #E7FBF3; }

  &.Negative:after {
    content: '';
    position: absolute;
    left: -10px;
    top: 6px;
    height: 20px;
    width: 20px;
    border-top: 1px solid #ADADAC;
    border-bottom: 1px solid #ADADAC;
    border-left: none;
    border-right: none;
    border-radius: 50%;
    background-color: transparent;
  }
  &.Negative span{ color: #EE2534; }
  &.Negative:hover{background-color: #FEE8EA}

  &.Mixed:after {
    content: '';
    position: absolute;
    left: -10px;
    top: 6px;
    height: 20px;
    width: 20px;
    border-top: 1px solid #ADADAC;
    border-bottom: 1px solid #ADADAC;
    border-left: none;
    border-right: none;
    border-radius: 50%;
    background-color: transparent;
  }
  &.Mixed span{ color: #353535; }
  &.Mixed:hover{ background-color: #ECEFF2;}


`)

export const InputContainer = styled(Box)(` `)

export const InputWrap = styled(Box)(`
    &.top {
        margin-bottom: 20px;
    }
    & label {
        margin-bottom: 2px;
    }
`)

export const ModalTitle = styled(Typography)(`
  margin-top: 10px;
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
  color: #000;
`)

export const ModalWrapper = styled(Box)(`
  width:100%;
  max-width: 600px;
  width: 80vw;
`)

export const ModalButton = styled(MuiButton)(`
  float: left;
  margin-left: 0px !important;
  margin-top: 20px !important;
`)

export const VerbatimWrap = styled(Box)((props) => `
    ${props.maxHeight ? `
    max-height : ${props.maxHeight}px;
    overflow-y : auto;  
    padding-right : 4px;

    // not working ${thinScrollbar}
     &::-webkit-scrollbar { width: 6px; }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(173, 173, 173, 1);  
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track { background: transparent; }

    &::-webkit-scrollbar-thumb:hover { background-color: #555; }   
  ` : ''}
`)
